export enum LockerDimensionIds {
  V3_Small = '70c21427-c84a-448d-94f7-7f41b55be6b8',
  V3_Medium = '3681c247-853c-4489-9006-80bd3b830426',
  V3_Large = 'e26c52ce-0817-46af-929b-3b40d529d173',
  V3_ExtraLarge = 'eeec52ce-0817-46af-929b-3b40d529d333',
  XXS = '86c390d4-25e7-4c66-ae9c-729e2e006547', // xxs
  XS = '50ef71bd-37c8-4565-848e-9df3a83a7b08', // backpack
  S = '230f25c3-bbaa-4af0-98c0-9eb6f0f02327', // s
  M = '1727e290-ecfd-4b4b-9cba-704b1ee5a8fc', // m
  L = '5191ac91-423c-491b-a1ec-6355a04e38d4', // large
  XL = '1737a070-f076-442e-a338-50e7db856e37', // xl
  XXL = 'c9bc54eb-149d-47d4-bf73-ded68a01927d',
  SKI_BOXES = 'fb4aa7d0-79e3-4d89-8e86-676de422070d', // former XXL
}
